"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_VALIDATED = exports.VALIDATE_DATE = exports.LOADING_ERROR = exports.LOADING_DONE = void 0;
// Event types used in the AppointmentWaitlist machines
exports.LOADING_DONE = '@event/LOADING_DONE';
exports.LOADING_ERROR = '@event/LOADING_ERROR';
exports.VALIDATE_DATE = '@event/VALIDATE_DATE';
exports.DATE_VALIDATED = '@event/DATE_VALIDATED';
exports.default = {
    LOADING_DONE: exports.LOADING_DONE,
    LOADING_ERROR: exports.LOADING_ERROR,
    VALIDATE_DATE: exports.VALIDATE_DATE,
    DATE_VALIDATED: exports.DATE_VALIDATED
};
//# sourceMappingURL=Events.js.map